function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import { DefaultButton, Dialog, DialogFooter, PrimaryButton, Spinner, SpinnerSize, Text } from '@fluentui/react';
import * as PropTypes from 'prop-types';
import { Constants } from '@shared/utils/constants';
import SpzaComponent from '../spzaComponent';
import { SpzaInstrumentService } from '../../services/telemetry/spza/spzaInstrument';
import { getWindow } from '@shared/services/window';
import { ReviewActionModal } from './reviewActionModal';
import successGreenV from '@shared/images/successGreenV.svg';
import redExclamationMark from '@shared/images/redExclamationMark.svg';
import { SubmitReviewResponseModal } from './submitReviewResponseModal';
import { getReviewModalDialogProps } from '@shared/utils/reviewsUtils';
import { logger } from '@src/logger';
export class RatingModal extends SpzaComponent {
    initMode() {
        var _this_props_payload_app_detailInformation;
        if (this.props.payload.accessKey) {
            this.auth = Constants.Headers.AccessKey;
            this.accessKey = this.props.payload.accessKey;
        } else {
            if (this.props.userInfo.signedIn) {
                this.auth = Constants.Headers.Authorization;
                this.accessKey = this.props.userInfo.accessToken.spza;
            } else {
                this.closeModal();
            }
        }
        if ((_this_props_payload_app_detailInformation = this.props.payload.app.detailInformation) === null || _this_props_payload_app_detailInformation === void 0 ? void 0 : _this_props_payload_app_detailInformation.LargeIconUri) {
            this.iconURL = this.props.payload.app.detailInformation.LargeIconUri;
        } else {
            this.iconURL = this.props.payload.app.iconURL;
        }
    }
    componentDidMount() {
        const reviewsData = this.props.reviewsData;
        const userReview = reviewsData.userReview;
        if (userReview) {
            var _userReview_customer_info;
            var _userReview_customer_info_is_anonymous;
            this.setState({
                showMode: Constants.RatingShowMode.EditReview,
                rating: userReview.rating,
                title: userReview.title || '',
                description: userReview.content || '',
                submitted: userReview.updated_at,
                isEdit: true,
                consent: false,
                showAnonymous: (_userReview_customer_info_is_anonymous = (_userReview_customer_info = userReview.customer_info) === null || _userReview_customer_info === void 0 ? void 0 : _userReview_customer_info.is_anonymous) !== null && _userReview_customer_info_is_anonymous !== void 0 ? _userReview_customer_info_is_anonymous : false
            });
        } else {
            this.setState({
                showMode: Constants.RatingShowMode.WriteNewReview,
                isEdit: false
            });
        }
    }
    getReviewFormData() {
        const { userReview } = this.props.reviewsData;
        return {
            offerId: this.props.payload.app.entityId,
            rating: this.state.rating,
            title: this.state.title,
            content: this.state.description,
            sendEmailConsent: this.state.consent,
            isAnonymous: this.state.showAnonymous,
            reviewId: userReview === null || userReview === void 0 ? void 0 : userReview.id
        };
    }
    handleSubmit() {
        this.setState({
            showMode: Constants.RatingShowMode.Loading
        });
        const reviewData = this.getReviewFormData();
        const { isEdit } = this.state;
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.RRSubmit,
            appName: this.props.payload.app.entityId,
            details: `${isEdit ? `A review of the app ${this.props.payload.app.entityId} was updated` : `A new review was inserted to the app ${this.props.payload.app.entityId}`}`
        };
        this.instrument.probe('logAndFlushTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
        const submitOperation$ = isEdit ? this.props.updateReview(reviewData) : this.props.submitReview(reviewData);
        submitOperation$.then(()=>{
            this.setState({
                showMode: Constants.RatingShowMode.Success
            });
            if (this.auth === Constants.Headers.Authorization) {
                this.props.setUserReviewStatus(true);
            }
            this.props.payload.callback('success');
        }).catch((err)=>{
            this.handleError(err);
        });
    }
    handleDelete() {
        this.setState({
            showMode: Constants.RatingShowMode.Loading
        });
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.RRDelete,
            appName: this.props.payload.app.entityId
        };
        this.instrument.probe('logAndFlushTelemetryInfo', payload);
        logger.info('', {
            action: payload.action,
            actionModifier: payload.actionModifier,
            appName: payload.appName
        });
        this.props.deleteReview(this.getReviewFormData()).then(()=>{
            this.setState({
                showMode: Constants.RatingShowMode.DeleteSuccess
            });
            this.props.payload.callback('success');
        }).catch((err)=>{
            this.handleError(err);
        });
    }
    handleError(err) {
        var _err_response, _err_response1, _err_response_statusCode, _err_response2, _err_response3;
        if (((_err_response = err.response) === null || _err_response === void 0 ? void 0 : _err_response.statusCode) === 400 && ((_err_response1 = err.response) === null || _err_response1 === void 0 ? void 0 : _err_response1.text) === Constants.ReviewsEnrichApiResponse.ContentViolation) {
            this.setState({
                showMode: Constants.RatingShowMode.ContentViolation
            });
        } else {
            this.setState({
                showMode: Constants.RatingShowMode.Error
            });
        }
        const errorStatusCode = (_err_response2 = err.response) === null || _err_response2 === void 0 ? void 0 : (_err_response_statusCode = _err_response2.statusCode) === null || _err_response_statusCode === void 0 ? void 0 : _err_response_statusCode.toString();
        const payload = {
            page: getWindow().location.href,
            action: Constants.Telemetry.Action.Click,
            actionModifier: Constants.Telemetry.ActionModifier.RRSubmit,
            details: `RatingModal got an error from the server. status code: ${errorStatusCode}, message: ${(_err_response3 = err.response) === null || _err_response3 === void 0 ? void 0 : _err_response3.text}.`
        };
        this.instrument.probe('logAndFlushTelemetryInfo', payload);
        logger.info(payload.details, {
            action: payload.action,
            actionModifier: payload.actionModifier
        });
    }
    closeModal() {
        this.props.dismissModal();
    }
    handleRatingChange(ratingNumber) {
        this.setState({
            rating: ratingNumber
        });
    }
    onChangeReviewTitle(titleText) {
        this.setState({
            title: titleText
        });
    }
    onChangeReviewContent(contentText) {
        this.setState({
            description: contentText
        });
    }
    setEnsureDeleteShowMode() {
        this.setState({
            showMode: Constants.RatingShowMode.EnsureDelete
        });
    }
    onChangeConsent() {
        this.setState({
            consent: !this.state.consent
        });
    }
    onChangeDisplayName() {
        this.setState({
            showAnonymous: !this.state.showAnonymous
        });
    }
    renderImpl() {
        if (this.state.showMode === Constants.RatingShowMode.Error) {
            return /*#__PURE__*/ _jsx(SubmitReviewResponseModal, {
                context: this.context,
                title: this.context.loc('ReviewActionModal_ErrorDialogTitle', "Your review wasn't published"),
                content: this.context.loc('ReviewActionModal_ErrorDialogText', 'There was a problem publishing the review because of technical issue.\nTry posting your review again.'),
                dialogIcon: redExclamationMark,
                shouldRenderLink: false,
                closeModal: this.closeModal.bind(this)
            });
        }
        if (this.state.showMode === Constants.RatingShowMode.ContentViolation) {
            return /*#__PURE__*/ _jsx(SubmitReviewResponseModal, {
                context: this.context,
                title: this.context.loc('ReviewActionModal_ErrorContentViolationDialogTitle', "Your review couldn't be published"),
                content: this.context.loc('ReviewActionModal_ErrorContentViolationDialogText', "We couldn't publish your review because we detected some offensive content\nwhich violates Microsoft terms."),
                dialogIcon: redExclamationMark,
                shouldRenderLink: true,
                closeModal: this.closeModal.bind(this)
            });
        }
        if (this.state.showMode === Constants.RatingShowMode.Success) {
            return /*#__PURE__*/ _jsx(SubmitReviewResponseModal, {
                context: this.context,
                title: this.context.loc('ReviewActionModal_SuccessDialogTitle', 'Thanks for your review'),
                content: this.context.loc('ReviewActionModal_SuccessDialogText', 'Thanks for taking the time to give your feedback.\nYour rating will be added to the average app rating shortly.'),
                dialogIcon: successGreenV,
                shouldRenderLink: false,
                closeModal: this.closeModal.bind(this)
            });
        }
        if (this.state.showMode === Constants.RatingShowMode.DeleteSuccess) {
            return /*#__PURE__*/ _jsx(SubmitReviewResponseModal, {
                context: this.context,
                title: this.context.loc('ReviewActionModal_DeleteSuccessDialogTitle', 'Your review has been deleted'),
                content: this.context.loc('ReviewActionModal_DeleteSuccessDialogText', 'We removed your review from the feed.'),
                dialogIcon: successGreenV,
                shouldRenderLink: false,
                closeModal: this.closeModal.bind(this)
            });
        }
        if (this.state.showMode === Constants.RatingShowMode.WriteNewReview) {
            return /*#__PURE__*/ _jsx(ReviewActionModal, {
                context: this.context,
                title: this.context.loc('ReviewActionModal_WriteBoxTitle', 'Review this app'),
                appTitle: this.props.payload.app.title,
                appPublisher: this.props.payload.app.publisher,
                userEmail: this.props.userInfo.email,
                userDisplayName: this.props.userInfo.displayName,
                appIcon: this.iconURL,
                curRating: this.state.rating,
                curReviewTitle: this.state.title,
                curReviewContent: this.state.description,
                isAnonymous: this.state.showAnonymous,
                userReview: this.props.reviewsData.userReview,
                closeModal: this.closeModal.bind(this),
                handleRatingChange: this.handleRatingChange.bind(this),
                handleReviewTitleChange: this.onChangeReviewTitle.bind(this),
                handleReviewContentChange: this.onChangeReviewContent.bind(this),
                handleSendEmailCheckbox: this.onChangeConsent.bind(this),
                handleDisplayUserNameCheckbox: this.onChangeDisplayName.bind(this),
                handleSubmitReview: this.handleSubmit.bind(this),
                handleDeleteReview: this.setEnsureDeleteShowMode.bind(this)
            });
        }
        if (this.state.showMode === Constants.RatingShowMode.EditReview) {
            return /*#__PURE__*/ _jsx(ReviewActionModal, {
                context: this.context,
                title: this.context.loc('ReviewActionModal_EditBoxTitle', 'Edit your review'),
                appTitle: this.props.payload.app.title,
                appPublisher: this.props.payload.app.publisher,
                userEmail: this.props.userInfo.email,
                userDisplayName: this.props.userInfo.displayName,
                appIcon: this.iconURL,
                curRating: this.state.rating,
                curReviewTitle: this.state.title,
                curReviewContent: this.state.description,
                isAnonymous: this.state.showAnonymous,
                userReview: this.props.reviewsData.userReview,
                closeModal: this.closeModal.bind(this),
                handleRatingChange: this.handleRatingChange.bind(this),
                handleReviewTitleChange: this.onChangeReviewTitle.bind(this),
                handleReviewContentChange: this.onChangeReviewContent.bind(this),
                handleSendEmailCheckbox: this.onChangeConsent.bind(this),
                handleDisplayUserNameCheckbox: this.onChangeDisplayName.bind(this),
                handleSubmitReview: this.handleSubmit.bind(this),
                handleDeleteReview: this.setEnsureDeleteShowMode.bind(this)
            });
        }
        if (this.state.showMode === Constants.RatingShowMode.EnsureDelete) {
            const dialogProps = getReviewModalDialogProps(this.context.loc('ReviewActionModal_EnsureDeleteTitle', 'Delete your review?'));
            dialogProps.modalProps.styles.main.minHeight = 150;
            return /*#__PURE__*/ _jsxs(Dialog, {
                hidden: false,
                onDismiss: ()=>this.closeModal(),
                dialogContentProps: dialogProps.dialogContentProps,
                maxWidth: dialogProps.maxWidth,
                modalProps: dialogProps.modalProps,
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        className: "ResponeDialogContent",
                        children: this.context.loc('ReviewActionModal_EnsureDeleteDialogText', "It won't appear in the reviews feed and won't be available any longer.")
                    }),
                    /*#__PURE__*/ _jsxs(DialogFooter, {
                        children: [
                            /*#__PURE__*/ _jsx(PrimaryButton, {
                                onClick: ()=>this.handleDelete(),
                                text: this.context.loc('Rating_DeleteButton', 'Delete')
                            }),
                            /*#__PURE__*/ _jsx(DefaultButton, {
                                onClick: ()=>this.closeModal(),
                                text: this.context.loc('Cancel', 'Cancel')
                            })
                        ]
                    })
                ]
            });
        }
        return /*#__PURE__*/ _jsx(Spinner, {
            className: "ratingModalLoading",
            size: SpinnerSize.large,
            label: this.context.loc('AppDetail_LoadingText', 'Loading...'),
            ariaLive: "assertive"
        });
    }
    constructor(props, context){
        super(props, context), _define_property(this, "context", void 0), _define_property(this, "auth", void 0), _define_property(this, "iconURL", void 0), _define_property(this, "accessKey", void 0), _define_property(this, "instrument", SpzaInstrumentService.getProvider());
        this.context = context;
        this.initMode();
        this.state = {
            showMode: Constants.RatingShowMode.Loading,
            rating: null,
            description: '',
            isEdit: false,
            title: '',
            submitted: '',
            consent: false,
            showAnonymous: false
        };
    }
}
RatingModal.contextTypes = {
    loc: PropTypes.func,
    locParams: PropTypes.func
};
